// extracted by mini-css-extract-plugin
export default {"integrationsWrapper":"integrationsWrapper__cKfLy","lineBreak":"lineBreak__qSeKk","integrationsFooter":"integrationsFooter__EUZGs"};